import { request } from 'api/request';

export const generateCode = async (data: {
  prompt: string;
  availableVariables: string[];
  currentCode?: string;
}) => {
  const response = await request.post('/v1/code/generate-code/', data);
  return response.data;
};

export const testCode = async (data: { code: string; inputs: Record<string, any> }) => {
  const response = await request.post('/v1/code/test-code/', data);
  return response.data;
};
